import { Product } from '@notino/web-tracking/dist/types/package/ga4/events/products';

import { dispatchTrackingEvent } from '@context/tracking/utils';

import { ProductDetail } from './hooks/useTracking/model';

const getTrackingProduct = (
  product: ProductDetail,
  listName?: 'skin_anl_pdp' | 'skin_anl_list'
): Product => ({
  brand_name: product.item_brand,
  full_price: product.price,
  kind: '',
  price: product.price,
  primary_subcategory: '',
  primary_category: product.item_category,
  primary_type: '',
  product_code: '',
  product_name: product.item_name,
  ...(listName && { list_name: listName }),
});

export const trackViewItem = (product: ProductDetail) => {
  const trackingProduct = getTrackingProduct(product, 'skin_anl_pdp');

  dispatchTrackingEvent({
    event: 'view_item',
    products: [trackingProduct],
    location: 'skin_anl',
    _clear: true,
  });
};
export const trackViewItemList = (products: ProductDetail[]) => {
  const trackingProducts = products.map((product) => ({
    ...getTrackingProduct(product),
    list_position: 0,
  }));

  dispatchTrackingEvent({
    event: 'view_item_list',
    product_lists: {
      list_name: 'skin_anl_list',
      interaction: 'click',
      sorting_type: 'automatic',
      products: trackingProducts,
    },
    _clear: true,
  });
};

export const trackAddToCard = (product: ProductDetail) => {
  const trackingProduct = getTrackingProduct(product);

  dispatchTrackingEvent({
    event: 'add_to_cart',
    product: {
      ...trackingProduct,
      quantity: 1,
      cart_type: 'skin_anl',
    },
    _clear: true,
  });
};

export const trackAddToWishList = (product: ProductDetail, timing: number) => {
  const trackingProduct = getTrackingProduct(product);

  dispatchTrackingEvent({
    event: 'add_to_wishlist',
    wishlist: {
      action: 'product_added_to_wishlist',
      interaction: 'click_add',
      type: 'skin_anl',
      timing,
      products: [trackingProduct],
    },
    _clear: true,
  });
};

export const trackRemoveFromWishList = (
  product: ProductDetail,
  timing: number
) => {
  const trackingProduct = getTrackingProduct(product);

  dispatchTrackingEvent({
    event: 'remove_from_wishlist',
    wishlist: {
      action: 'product_removed_from_wishlist',
      interaction: 'click_add',
      type: 'skin_anl',
      timing,
      products: [trackingProduct],
    },
    _clear: true,
  });
};

export const trackViewOrSelectPromotion = (
  brand: string,
  event: 'select_promotion' | 'view_promotion'
) => {
  dispatchTrackingEvent({
    event,
    promotions: [
      {
        code: 'skin_anl',
        id: brand,
        location: 'skin_anl_pdp',
        creative: '',
        destination_url: '',
        name: '',
        position: 0,
      },
    ],
    _clear: true,
  });
};
